<div class="container">

    <div class="row mb-4">
        <div class="col-md-12">
            <h4 class="text-primary mb-4">{{ data.TITLE }}</h4>
            <p>{{ data.SUB_TITLE }}</p>
        </div>
    </div>

    <div class="row">
        <div class="col-md-12">
            <div class="card">
                <div class="card-header bg-primary text-white">
                    <h5 class="mb-0">{{ data.CARD_TITLE_VANTAGENS }}</h5>
                </div>
                <div class="card-body">
                    <ul class="navbar-nav">
                        <div *ngFor="let info of data.VANTAGENS; let lastItem = last; let index = index">
                            <li class="nav-item">
                                <p>{{ info.TITLE }}</p>
                            </li>
                        </div>
                    </ul>
                </div>
            </div>
        </div>
    </div>

    <div class="row d-flex justify-content-center mt-4">

        <div class="col-md-6 d-flex align-items-stretch mb-4">
            <div class="card w-100">
                <div class="card-header bg-primary text-white">
                    <h5 class="mb-0">{{ data.CARD_TITLE_PRODUZ }}</h5>
                </div>
                <div class="card-body">
                    <p>{{ data.CARD_DESCRICAO_PRODUZ }}</p>
                    <p>{{ data.CARD_FOOTER_PRODUZ }}
                        <a class='font-weight-bold' [routerLink]="[ data.URL_TESTE_GRATIS ] | localize">{{
                            data.TESTE_GRATIS }}</a>
                    </p>
                </div>
            </div>
        </div>

        <div class="col-md-6 d-flex align-items-stretch mb-4">
            <div class="card w-100">
                <div class="card-header bg-primary text-white">
                    <h5 class="mb-0">{{ data.CARD_TITLE_ENVIA }}</h5>
                </div>
                <div class="card-body">
                    <p>{{ data.CARD_DESCRICAO_ENVIA }} <a class='font-weight-bold'
                            [routerLink]="[ data.URL_CONTATO ] | localize">{{ data.CARD_FOOTER_ENVIA }}</a>
                    </p>
                </div>
            </div>
        </div>

    </div>

</div>